export default __webpack_public_path__ + "static/rennerboldarchitype-webfont-db4b009d1098ea749abbdb926013bc28.woff2";